const list = {
    or: 'أو',
    and: 'و',
    separator: '،',
};
export default Object.freeze(list);
